import React, { useState, lazy } from 'react';
import { groupStack, resolveChips, type StackChip } from '../cv/techMeta';
/** Clean code glyph for concept tags with no brand logo (matches the CV). */
function GenericGlyph() {
  return <svg viewBox="0 0 24 24" aria-hidden="true" className="h-[11px] w-[11px] shrink-0" fill="none" stroke="#a8a29e" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-317" data-mp="3iy0sktsrmg75">
      <polyline points="8 6 3 12 8 18" data-id="element-318" data-mp="2q9bvd5utyv0o" />
      <polyline points="16 6 21 12 16 18" data-id="element-319" data-mp="2la8r3nmocstr" />
    </svg>;
}
/** Squared chip with a full-colour brand logo — dark-theme sibling of the CV chip. */
function Chip({
  item
}: {
  item: StackChip;
}) {
  const [ok, setOk] = useState(Boolean(item.slug));
  const showBrand = item.slug && ok;
  return <span className="inline-flex items-center gap-1.5 rounded-sm border border-white/10 bg-white/[0.04] px-1.5 py-[3px] font-mono text-[10px] text-stone-300" data-id="element-320" data-mp="ejj4es8p041z">
      {showBrand ? <img src={`https://cdn.simpleicons.org/${item.slug}/a8a29e`} alt="" aria-hidden="true" loading="lazy" onError={() => setOk(false)} className="h-[11px] w-[11px] object-contain opacity-90" data-id="element-321" data-mp="aka7jeicvq27" /> : <GenericGlyph data-id="element-322" data-mp="1nft2kunwbdc5" />}
      {item.label}
    </span>;
}
/**
 * Grouped tech stack for a role — mirrors the CV's TechStack: a "Stack" label,
 * then Frontend / Backend & Cloud / Practices rows with an accent group label,
 * squared chips and consistent spacing. Dark-themed.
 */
export function TechStack({
  stack
}: {
  stack: string[];
}) {
  const groups = groupStack(stack);
  if (groups.length === 0) return null;
  return <div className="mt-5 border-t border-white/10 pt-4" data-id="element-323" data-mp="19f8kk0pt1ljp">
      <p className="mb-3 font-mono text-[9px] uppercase tracking-[0.24em] text-stone-500" data-id="element-324" data-mp="19gtebo4ap0gi">
        Stack
      </p>
      <div className="space-y-2.5" data-id="element-325" data-mp="bzkyupwq9vyw">
        {groups.map(g => <div key={g.group} className="flex flex-wrap items-start gap-x-3 gap-y-1.5" data-id="element-326" data-mp="gxw931qxq8hn">
            <span className="mt-[3px] w-[104px] shrink-0 font-mono text-[9px] uppercase tracking-[0.14em] text-[var(--accent)]" data-id="element-327" data-mp="1k80l0l04cn5a">
              {g.group}
            </span>
            <div className="flex flex-1 flex-wrap gap-1.5" data-id="element-328" data-mp="1t13uyjbk2hv6">
              {g.items.map(item => <Chip key={item.label} item={item} data-id="element-329" data-mp="1p1mq9s3ydor2" />)}
            </div>
          </div>)}
      </div>
    </div>;
}
/** Flat chip row (no grouping) — used by the Capabilities section. */
export function TechPills({
  labels
}: {
  labels: string[];
}) {
  const chips = resolveChips(labels);
  return <div className="flex flex-wrap gap-1.5" data-id="element-330" data-mp="1ad8lvcqw1s8e">
      {chips.map(c => <Chip key={c.label} item={c} data-id="element-331" data-mp="15bj8vrk3v4ho" />)}
    </div>;
}